import 'scss/solutions/accompanied-reading.scss'
import 'babel-polyfill'
import 'js/libs/utils-solutions'



// WEBPACK FOOTER //
// ./src/js/entry/solutions/accompanied-reading.js